import { Environment } from '@/shared/models/appConfig.model';
import type { App, ObjectPlugin } from 'vue';

const DEFAULT_ACTION_TYPE = 'user-level analytics';
const dtrum = window.dtrum ?? null;

const enterAction = (actionName: string, actionType?: string) => {
  if (window.appConfig.env === Environment.PROD) {
    try {
      return dtrum?.enterAction(actionName, actionType ?? DEFAULT_ACTION_TYPE);
    } catch (_error) {
      /* empty */
    }
  } else {
    // eslint-disable-next-line no-console
    console.debug(`[Dynatrace enterAction]: ${actionName}`);
  }
};

const leaveAction = (actionId?: string) => {
  if (window.appConfig.env === Environment.PROD) {
    try {
      dtrum?.leaveAction(actionId ?? '');
    } catch (_error) {
      /* empty */
    }
  } else {
    // eslint-disable-next-line no-console
    console.debug(`[Dynatrace leaveAction]: ${actionId}`);
  }
};

const reportError = (err: string, parentActionId: string) => {
  if (window.appConfig.env === Environment.PROD) {
    try {
      dtrum?.reportError(err, parentActionId);
    } catch (_error) {
      /* empty */
    }
  } else {
    // eslint-disable-next-line no-console
    console.warn(`[Dynatrace reportError]: ${err}`);
  }
};

const reportCustomError = (
  key: string,
  value: string,
  hint?: string,
  parentingInfo?: number | boolean
): void => {
  if (window.appConfig.env === Environment.PROD) {
    // reportCustomError(key: string, value: string, hint?: undefined | string, parentingInfo?: number | boolean): void
    try {
      dtrum?.reportCustomError(key, value, hint, parentingInfo);
    } catch (_error) {
      /* empty */
    }
  } else {
    // eslint-disable-next-line no-console
    console.error(`[Dynatrace reportCustomError]: ${key} - ${value}`);
  }
};

const identifyUser = (value: string) => {
  // identifyUser(value: string): void
  if (window.appConfig.env === Environment.PROD) {
    try {
      dtrum?.identifyUser(value);
    } catch (_error) {
      /* empty */
    }
  } else {
    // eslint-disable-next-line no-console
    console.debug(`[Dynatrace identifyUser]: ${value}`);
  }
};

const _api = {
  enterAction,
  leaveAction,
  reportError,
  reportCustomError,
  identifyUser,
};

export interface IDynatraceClient {
  enterAction: (actionName: string, actionType?: string) => string | undefined;
  leaveAction: (actionId?: string) => void;
  reportError: (err: string, parentActionId: string) => void;
  reportCustomError: (
    key: string,
    value: string,
    hint?: string,
    parentingInfo?: number | boolean
  ) => void;
  identifyUser: (value: string) => void;
}

// Plugin Definition
export const dynatracePlugin: ObjectPlugin = {
  install(vueApp: App) {
    if (vueApp.config.globalProperties.$dynatrace !== _api) {
      vueApp.config.globalProperties.$dynatrace = _api;
    }
  },
};

export default _api;
